import { useMemo, useState } from 'react';

export const useAnchorCardDataInitialiser = () => {
  const [anchorCard, setAnchorCard] = useState(null);

  const returnValue = useMemo(
    () => ({
      anchorCard,
      setAnchorCard,
    }),
    [anchorCard]
  );

  return returnValue;
};
